(function() {
   angular
       .module('app')
       .directive('document', document);

   document.$inject = ['$timeout', '$parse'];

   function document($timeout, $parse) {
       return {
           require: 'ngModel',
           scope: { documentType: '=document' },
           link: function(scope, element, attrs, ctrl) {
           	console.log("ENTRO");
               ctrl.$validators.document = function(modelValue, viewValue) {
                   var dni = viewValue;
                   
                   if (ctrl.$isEmpty(modelValue)) {
                       // tratamos los modelos vacíos como incorrectos
                       return false;
                   }

                   var validDNI = function(dni) {
                   		if (!dni || dni.length !== 9) {
							return false;
						}
                       var dni_letters = "TRWAGMYFPDXBNJZSQVHLCKE";
                       dni = dni.toUpperCase();
                       var letter = dni_letters.charAt(parseInt(dni, 10) % 23);

                       return letter == dni.charAt(8);
                   };

                   var validNIE = function(nie) {
                       nie = nie.toUpperCase();

                       // Change the initial letter for the corresponding number and validate as DNI
                       var nie_prefix = nie.charAt(0);

                       switch (nie_prefix) {
                           case 'X':
                               nie_prefix = 0;
                               break;
                           case 'Y':
                               nie_prefix = 1;
                               break;
                           case 'Z':
                               nie_prefix = 2;
                               break;
                       }

                       return validDNI(nie_prefix + nie.substr(1));

                   };
                   /*if (scope.documentType == 'DNI' || scope.documentType == 'NIF') {
                       return validDNI(viewValue);
                   } else {
                    return validNIE(viewValue)
                   }*/

                   function isValidCif(cif) {
						if (!cif || cif.length !== 9) {
							return false;
						}

						var letters = ['J', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];
						var digits = cif.substr(1, cif.length - 2);
						var letter = cif.substr(0, 1);
						var control = cif.substr(cif.length - 1);
						var sum = 0;
					  	var i;
						var digit;

						if (!letter.match(/[A-Z]/)) {
							return false;
						}

						for (i = 0; i < digits.length; ++i) {
							digit = parseInt(digits[i]);

							if (isNaN(digit)) {
								return false;
							}

							if (i % 2 === 0) {
								digit *= 2;
								if (digit > 9) {
									digit = parseInt(digit / 10) + (digit % 10);
								}

								sum += digit;
							} else {
								sum += digit;
							}
						}

						sum %= 10;
						if (sum !== 0) {
							digit = 10 - sum;
						} else {
							digit = sum;
						}

						if (letter.match(/[ABEH]/)) {
							return String(digit) === control;
						}
						if (letter.match(/[NPQRSW]/)) {
							return letters[digit] === control;
						}

						return String(digit) === control || letters[digit] === control;
					}



                   console.log(validDNI(viewValue) || validNIE(viewValue) || isValidCif(viewValue));
                   // NIF inválido
                   return validDNI(viewValue) || validNIE(viewValue) || isValidCif(viewValue);


               };

           }
       }

   }
})();